"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDisplay = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
const path_1 = tslib_1.__importDefault(require("path"));
const react_1 = tslib_1.__importDefault(require("react"));
const FileIcon_1 = require("./FileIcon");
const GridWrapper = styled_1.default(react_core_1.Box) `
  display: grid;
  grid-auto-flow: column;
  gap: 4px;
  align-items: start;
`;
const StyledFileIcon = styled_1.default(FileIcon_1.FileIcon) `
  height: 16px;
  width: 16px;
`;
exports.FileDisplay = (_a) => {
    var { file, omitReadOnly } = _a, props = tslib_1.__rest(_a, ["file", "omitReadOnly"]);
    return (react_1.default.createElement(GridWrapper, Object.assign({}, props),
        react_1.default.createElement(StyledFileIcon, { path: file.path }),
        `${path_1.default.basename(file.path)}${omitReadOnly || file.writable ? '' : ' (read-only)'}`));
};

//# sourceMappingURL=FileDisplay.js.map
